import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { ConfirmationModal } from '../../Confirmation'
import { CONFIRMATION_QA_NAME_FORM_MODAL } from '../Form.constants'

function FormModalConfirmation({
  actionButtonsProps: {
    cancelText: actionButtonsCancelText = 'Modal.CommonGoBackBtnKey',
    submitText: actionButtonsSubmitText = 'Modal.CommonDiscardBtnKey',
    ...actionButtonsProps
  } = EMPTY_OBJECT,
  description = 'Modal.CancelConfirmationTitleKey',
  qaName = CONFIRMATION_QA_NAME_FORM_MODAL,
  title = 'Common.AttentionModalTitleKey',
  onCancel,
  onSubmit,
  ...confirmationProps
}) {
  const { t } = useTranslation()

  return (
    <ConfirmationModal
      {...confirmationProps}
      actionButtonsProps={{
        ...actionButtonsProps,
        cancelText: t(actionButtonsCancelText),
        submitText: t(actionButtonsSubmitText),
      }}
      description={t(description)}
      qaName={qaName}
      title={t(title)}
      onCancel={onCancel}
      onClose={onCancel}
      onSubmit={onSubmit}
    />
  )
}

export default FormModalConfirmation
